import { useScreenSize } from '~/context/common/DeviceContext';

const MOBILE = 768;
const MOBILE_SM = 375;
const MOBILE_XS = 320;
const TABLET = 768;
const DESKTOP = 1024;
const DESKTOP_MEDIUM = 1280;
const DESKTOP_LARGE = 1440;
const DESKTOP_X_LARGE = 1920;

export default function useViewport() {
  const { width } = useScreenSize();

  return {
    isMobile: width < MOBILE,
    isSmallMobile: width < MOBILE_SM,
    isXSmallMobile: width < MOBILE_XS,
    isTablet: width >= TABLET && width < DESKTOP,
    isDesktop: width >= DESKTOP,
    isDesktopMedium: width >= DESKTOP_MEDIUM,
    isLargeDesktop: width >= DESKTOP_LARGE,
    isExtraLargeDesktop: width >= DESKTOP_X_LARGE
  };
}
